// extracted by css-extract-rspack-plugin
export default {"list":"list--v5eSUsX25DAfVvUT","link":"link--mo9guTi9UfsIZlZ1"};